import apiClient from 'api/apiConfig';
import { Logs } from './LogType';

export const getLogData = async ({
  jobId,
  startTime,
}: {
  jobId: number;
  startTime: string;
}) => {
  const response = await apiClient.post<Logs>('csb/jobs/log', {
    CSBJobId: jobId,
    fromTimeCSB: startTime,
  });
  return response.data;
};
